"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOP_AREA_BANNER_HEIGHT = exports.TOP_AREA_BANNER_BENEFIT_BANNER = void 0;
const TOP_AREA_BANNER_HEIGHT = exports.TOP_AREA_BANNER_HEIGHT = 34;
const TOP_AREA_BANNER_BENEFIT_BANNER = exports.TOP_AREA_BANNER_BENEFIT_BANNER = 'top-area-banner-benefit-banner';
